import key from 'weak-key';
import { Divider } from '@geberit/gdds';

// styles
import styles from './investors-calendar.module.scss';

// types
import type { CalendarEvent } from './investors-calendar.types';

// components
import { Headline, Formats, FontWeights } from 'components/ContentElements/Headline';
import InvestorsCalendarRow from './investors-calendar-row';

// utils
import { isEmpty } from 'utils/is-empty';
import { useKolo } from 'utils/hooks/use-kolo';

interface EventsContentProps {
  pastEvents: CalendarEvent[];
  upcomingEvents: CalendarEvent[];
  pastEventsTitle: string;
  futureEventsTitle: string;
  locale: Locale;
  language: string;
}

function EventsContent({
  pastEvents,
  upcomingEvents,
  pastEventsTitle,
  futureEventsTitle,
  locale,
  language,
}: Readonly<EventsContentProps>) {
  const isKolo = useKolo();
  return (
    <>
      {!isEmpty(upcomingEvents) && (
        <div className={styles.upcomingEventsContent}>
          <Headline
            tag={Formats.h2}
            title={futureEventsTitle}
            titleFontWeight={isKolo ? FontWeights.bold : FontWeights.light}
            subtitleFontWeight={isKolo ? FontWeights.bold : undefined}
            format={Formats.h3}
            titlePreviewId="#st_titleFuture"
          />
          <Divider />
          {upcomingEvents.map((entry) => (
            <InvestorsCalendarRow
              {...entry}
              key={key({ entry })}
              locale={locale}
              language={language}
            />
          ))}
        </div>
      )}
      {!isEmpty(pastEvents) && (
        <div className={styles.pastEvents}>
          <Headline
            tag={Formats.h2}
            title={pastEventsTitle}
            titleFontWeight={isKolo ? FontWeights.bold : FontWeights.light}
            subtitleFontWeight={isKolo ? FontWeights.bold : undefined}
            format={Formats.h3}
            titlePreviewId="#st_titlePast"
          />
          <Divider />
          {pastEvents.map((entry) => (
            <InvestorsCalendarRow
              {...entry}
              key={key({ entry })}
              withoutAgenda
              pastEvent
              locale={locale}
              language={language}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default EventsContent;
